import * as React from 'react';
import styled from 'styled-components';

import { Button } from 'components/bootstrap';
import { Icon } from 'components/common';
import { useModalContext } from 'common/contexts';
import useCurrentUser from 'hooks/useCurrentUser';
import { isPermitted } from 'util/PermissionsMixin';

// import ProceduresList from './List';
import ProceduresList from './EventProcedureList';
import StepsList from './EventProcedureStepList';

const Container = styled.div`
  margin: 24px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const ButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
`;

function PageHeader({ viewType }: { viewType: string }) {
  const { setModal } = useModalContext();
  const { permissions } = useCurrentUser();
  const canCreateEventProcedures = React.useMemo(
    () => isPermitted(permissions, 'event_procedures:create'),
    [permissions],
  );
  const canCreateEventProcedureSteps = React.useMemo(
    () => isPermitted(permissions, 'event_procedure_steps:create'),
    [permissions],
  );

  const openEventProcedureModal = () => {
    setModal('CREATE-EVENT-PROCEDURE');
  };

  const openEventProcedureStepModal = () => {
    setModal('CREATE-EVENT-PROCEDURE-STEP');
  };

  const createButton = () => {
    if (viewType === 'procedures') {
      return (
        <Button bsStyle="primary" onClick={() => openEventProcedureModal()}>
          <Icon name="add" size="xs" />
          Create Event Procedure
        </Button>
      );
    }

    return (
      <Button bsStyle="primary" onClick={() => openEventProcedureStepModal()}>
        <Icon name="add" size="xs" />
        Create Event Procedure Step
      </Button>
    );
  };

  return (
    <Container>
      {((canCreateEventProcedures && viewType === 'procedures') ||
        (canCreateEventProcedureSteps && viewType === 'steps')) && <ButtonsRow>{createButton()}</ButtonsRow>}
    </Container>
  );
}

type Props = {
  viewType: string;
  useCoreRoutes?: boolean;
};

function GeneralUI({ viewType, useCoreRoutes = false }: Props) {
  return (
    <>
      {viewType === 'procedures' ? (
        <>
          <PageHeader viewType={viewType} />
          <ProceduresList useCoreRoutes={useCoreRoutes} />
        </>
      ) : (
        <>
          <PageHeader viewType={viewType} />
          <StepsList useCoreRoutes={useCoreRoutes} />
        </>
      )}
    </>
  );
}

export default GeneralUI;
